var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_14727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2318 5.01954C18.8269 3.66015 21.1731 3.66015 22.7682 5.01954L25.4815 7.33176C26.1651 7.91429 27.015 8.26633 27.9102 8.33777L31.4638 8.62135C33.553 8.78807 35.2119 10.447 35.3787 12.5362L35.6622 16.0898C35.7337 16.985 36.0857 17.8349 36.6682 18.5185L38.9805 21.2318C40.3398 22.8269 40.3398 25.1731 38.9805 26.7682L36.6682 29.4815C36.0857 30.1651 35.7337 31.015 35.6622 31.9102L35.3787 35.4638C35.2119 37.553 33.553 39.2119 31.4638 39.3787L27.9102 39.6622C27.015 39.7337 26.1651 40.0857 25.4815 40.6682L22.7682 42.9805C21.1731 44.3398 18.8269 44.3398 17.2318 42.9805L14.5185 40.6682C13.8349 40.0857 12.985 39.7337 12.0898 39.6622L8.53623 39.3787C6.44705 39.2119 4.78807 37.553 4.62135 35.4638L4.33777 31.9102C4.26633 31.015 3.91429 30.1651 3.33176 29.4815L1.01954 26.7682C-0.339847 25.1731 -0.339847 22.8269 1.01954 21.2318L3.33176 18.5185C3.91429 17.8349 4.26633 16.985 4.33777 16.0898L4.62135 12.5362C4.78807 10.447 6.44705 8.78807 8.53623 8.62135L12.0898 8.33777C12.985 8.26633 13.8349 7.91429 14.5185 7.33176L17.2318 5.01954Z",
    fill: "#92F048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8268 22.2384C29.8031 21.262 29.8031 19.6791 28.8268 18.7028C27.8505 17.7265 26.2676 17.7265 25.2913 18.7028L28.8268 22.2384ZM17.6473 29.8824L15.8795 31.6501C16.3484 32.119 16.9842 32.3824 17.6473 32.3824C18.3103 32.3824 18.9462 32.119 19.4151 31.6501L17.6473 29.8824ZM14.7092 23.4087C13.7329 22.4324 12.15 22.4324 11.1736 23.4087C10.1973 24.385 10.1973 25.9679 11.1736 26.9442L14.7092 23.4087ZM25.2913 18.7028L15.8795 28.1146L19.4151 31.6501L28.8268 22.2384L25.2913 18.7028ZM19.4151 28.1146L14.7092 23.4087L11.1736 26.9442L15.8795 31.6501L19.4151 28.1146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_14727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPopupIcon);
export default __webpack_public_path__ + "static/media/success-popup__icon.04c10f3ec6c495d4e120dfb4aa486a51.svg";
export { ForwardRef as ReactComponent };